import { createFetchAction, dateTimeToUtc } from '@mews-commander/utils';
import prefix from './prefix';

const OCCUPANCY_FETCHING = prefix('OCCUPANCY_FETCHING');
export const OCCUPANCY_FETCHING_STARTED = OCCUPANCY_FETCHING + '_STARTED';
export const OCCUPANCY_FETCHING_FAILED = OCCUPANCY_FETCHING + '_FAILED';
export const OCCUPANCY_FETCHING_SUCCEEDED = OCCUPANCY_FETCHING + '_SUCCEEDED';

export const fetchOccupancy =
    (start: $TSFixMe, end: $TSFixMe, serviceId: $TSFixMe) =>
    (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        const { serviceComponent } = container();
        const startUtc = dateTimeToUtc(start);
        const endUtc = dateTimeToUtc(end);
        const promise = serviceComponent
            .getOccupancy({ startUtc, endUtc, serviceId })
            .then((data: $TSFixMe) => ({
                data,
                startUtc,
                endUtc,
                serviceId,
            }))
            .catch((error: $TSFixMe) => {
                error.startUtc = startUtc;
                error.endUtc = endUtc;
                throw error;
            });

        return dispatch(createFetchAction(OCCUPANCY_FETCHING, { promise, data: { startUtc, endUtc } }));
    };
